import React from "react";
import { Box, Chip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ProgramDto } from "@growth-machine-llc/stridist-api-client";
import { FileText, User } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    flexWrap: "wrap",
  },

  chip: {
    height: 22,
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1),
    },
    "& .MuiChip-icon": {
      fontSize: 14,
      marginLeft: theme.spacing(0.75),
      color: theme.palette.primary.contrastText,
    },
  },
}));

export interface ProgramOriginBadgeProps {
  program?: ProgramDto;
  className?: string;
}

export function ProgramOriginBadge(props: ProgramOriginBadgeProps) {
  const { program, className } = props;
  const s = useStyles();

  const hasAuthor = !!program?.duplicatedFromAuthor;
  const hasTemplate = !!program?.templateName;

  if (!hasAuthor && !hasTemplate) {
    return null;
  }

  return (
    <Box className={`${s.root} ${className || ""}`}>
      {hasAuthor && (
        <Chip
          className={s.chip}
          icon={<User size={14} />}
          label={program.duplicatedFromAuthor.displayName}
          size="small"
        />
      )}
      {hasTemplate && (
        <Chip
          className={s.chip}
          icon={<FileText size={14} />}
          label={program.templateName}
          size="small"
        />
      )}
    </Box>
  );
}
